// extracted by mini-css-extract-plugin
export default {"quick-button":"sCQlD","quick-button__icon-btn":"aZhu2","quick-button__text":"YDA7r"};